@if (isMobile) {
<img src="/assets/StartingEleven.jpg" width="100%" />
} @else {
<img class="center" src="/assets/StartingEleven.jpg" />
}

<div class="s11-padding">
  @if (authStore.user() !== undefined) {
  <h1 class="text-center home-padding-top">
    Hallo, {{ authStore.userName() }}!
  </h1>

  @if (configStore.bets()) {
  <s11-betting-game />
  }
  <s11-stats />
  }
</div>

<!-- Social feed -->
<!-- <div class="icon-bar">
  <a
    href="https://www.facebook.com/hvtdpstainz/"
    target="_blank"
    class="facebook">
    <svg class="fa-brands fa-facebook"></svg>
  </a>
  <a href="https://twitter.com/HvStainz/" target="_blank" class="twitter">
    <svg class="fab fa-twitter"></svg>
  </a>
  <a href="mailto:hvtdpstainz@gmx.at" class="mail">
    <svg class="fa fa-envelope"></svg>
  </a>
  <a
    href="https://www.instagram.com/hvtdpstainz_2014/"
    target="_blank"
    class="instagram">
    <svg class="fab fa-instagram"></svg>
  </a>
</div> -->
